import React,{useState} from 'react';
import './Header.scss';



const ChangePassword = () => {

const [oldPassword,setOldPassword]=useState('');
const [newPassword,setNewPassword]=useState('');
const [confirmPassword,setConfirmPassword]=useState('');

//const [passwordError,setPasswordError]=useState(' ')
//const [sucessMsg, setSuccessMsg]=useState(' ');


const handleFormSubmit=(e)=>{
e.preventDefault();
}

return( 

<div className='change password'>
<form className='reset-form' onSubmit={handleFormSubmit}>
<h3 className="reset-page">Reset Password </h3>

<div className="form-group">
<label>Password</label>
<input type="text" className="form-control" 
onChange={ e => setOldPassword(e.target.value) }
value={oldPassword}/>
</div>

<div className="form-group">
<label>New Password</label>
<input type="text" className="form-control" 
onChange={ e => setNewPassword(e.target.value) }
value={newPassword}/>
</div>

<div className="form-group">
<label>Confirm Password</label>
<input type="text" className="form-control" 
onChange={ e => setConfirmPassword(e.target.value) }
value={confirmPassword}/>
</div>

<div className="main">
<button type="submit" className='cancel-form'>Cancel</button>
<button type="submit" className='submit-form'>Submit</button>
</div>

</form> 
</div> 

);
}
export default ChangePassword;


// WEBPACK FOOTER //
// ./common/Header/ChangePassword.js